<template>
  <div @click="goOrder" class="pcc">
    <div class="pcc-center">
      <img :src="brandInfo.shareImage" alt="" style="width: 50vw" />
    </div>
    <div class="mask" v-if="!type"></div>
    <div class="box">
      <div class="cont">
        <div>点击下方“使用完整服务”</div>
        <div>授权个人信息</div>
      </div>
      <div class="triangle"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      type: false,
    };
  },
  computed: {
    ...mapState(["brandInfo"]),
  },
  methods: {
    goOrder() {
      this.type= true;
      const { origin, pathname } = location
      const redirect = decodeURIComponent(this.$route.query.redirect)
      location.href = `${origin}${pathname}#${redirect}`
    },
  },
};
</script>

<style lang="less">
.pcc {
  background-color: #fff;
  width: 100vw;
  height: var(--dynamic-vh);
  position: relative;
  .pcc-center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
.mask {
  background-color: rgba(0, 0, 0, 0.7);
  /* 使用固定定位让元素撑满全屏 */
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.pcc-fox {
  position: fixed;
  bottom: 0;
  right: 0;
  width: 100px;
  height: 100px;
  background: #fff;
  border: 8px solid;
  border-color: transparent lightblue transparent transparent;
}
.box {
  position: fixed;
  bottom: 0;
  right: 20px;
}
.triangle {
  width: 0;
  height: 0;
  border: 12px solid transparent;
  border-top-color: #fff;
  margin-left: 200px;
}
.cont {
  width: 260px;
  height: 80px;
  background-color: #fff;
  border-radius: 15px;
  padding: 10px;
  div {
    text-align: center;
    font-size: 14px;
    padding: 5px;
  }
}
</style>
